import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { REMOVE_404_ERROR } from 'containers/App/constants';
import APModal from 'components/Modal/APModal';

const NotFoundModal = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const handleModalDismiss = () => {
    dispatch({
      type: REMOVE_404_ERROR,
    });
    history.push('/app/v2/projects');
  };

  return (
    <APModal
      open
      title="Uh oh! There's a teeny problem."
      onClose={handleModalDismiss}
      actions={(
        <button
          className="button"
          onClick={handleModalDismiss}
        >
          Got it
        </button>
      )}
    >
      <p>
        It looks like this page is no longer available.
        If you believe you’re receiving this message in error, reach out
        to your account owner or connect with Aisle Planner customer support
        &nbsp;<a
          href="https://www.aisleplanner.com/contact-us-pro"
          target="_blank"
          rel="noreferrer noopener"
        >here</a>.
      </p>
    </APModal>
  );
};

export default NotFoundModal;
